import {GraphQLError} from './types';

/**
 * Error related to HTTP error status codes.
 */
export class QueryStorefrontAPIError extends Error {
  public name = 'QueryStorefrontAPIError';

  constructor(public readonly errors: GraphQLError[]) {
    super(
      `Server messages: ${errors.map((error) => error.message).join('; ')}`,
    );
  }
}

/**
 * Error related to the Fetch API.
 */
export class FetchAPIError extends Error {
  public name = 'FetchAPIError';

  constructor(
    public readonly reason: unknown = 'An error occurred while fetching the data.',
  ) {
    super(reason?.toString());
  }
}

export class NetworkError extends Error {
  public name = 'NetworkError';
}

export class ForcedError extends Error {
  public name = 'ForcedError';
}
